import { Form, FormInstance, Input, Select } from 'antd';
import React from 'react';
import { TwilioJobPosition } from '../../types/twilio-onboarding';
import { formatPhoneE164 } from './onboarding-logic';

const JOB_POSITIONS: TwilioJobPosition[] = [
  'CEO',
  'CFO',
  'VP',
  'GM',
  'Director',
  'General Counsel',
  'Other',
];

interface AuthorizedRepFormProps {
  form: FormInstance;
}

export const AuthorizedRepForm: React.FC<AuthorizedRepFormProps> = ({
  form,
}) => {
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Form.Item
          label="First Name"
          name={['authorized_rep', 'first_name']}
          rules={[{ required: true, message: 'First name is required' }]}
        >
          <Input placeholder="John" />
        </Form.Item>

        <Form.Item
          label="Last Name"
          name={['authorized_rep', 'last_name']}
          rules={[{ required: true, message: 'Last name is required' }]}
        >
          <Input placeholder="e.g. Smith" />
        </Form.Item>
      </div>

      <Form.Item
        label="Email"
        name={['authorized_rep', 'email']}
        rules={[
          { required: true, message: 'Email is required' },
          { type: 'email', message: 'Please enter a valid email' },
        ]}
      >
        <Input placeholder="e.g. name@company.com" />
      </Form.Item>

      <Form.Item
        label="Phone"
        name={['authorized_rep', 'phone']}
        rules={[
          { required: true, message: 'Phone is required' },
          {
            pattern: /^\+1\d{10}$/,
            message: 'Phone must be in E.164 format (+1XXXXXXXXXX)',
          },
        ]}
      >
        <Input
          onBlur={e => {
            const raw = e.target.value;
            if (!raw) {
              return;
            }
            const formatted = formatPhoneE164(raw);
            if (formatted !== raw) {
              form.setFieldValue(['authorized_rep', 'phone'], formatted);
              form.validateFields([['authorized_rep', 'phone']]);
            }
          }}
          placeholder="+16025551234"
        />
      </Form.Item>

      <Form.Item
        label="Business Title"
        name={['authorized_rep', 'business_title']}
        rules={[{ required: true, message: 'Business title is required' }]}
      >
        <Input placeholder="e.g. Company Name, LLC" />
      </Form.Item>

      <Form.Item
        label="Job Position"
        name={['authorized_rep', 'job_position']}
        rules={[{ required: true, message: 'Job position is required' }]}
      >
        <Select placeholder="Select job position">
          {JOB_POSITIONS.map(p => (
            <Select.Option key={p} value={p}>
              {p}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};
